import { useEffect, useState } from "react"

export default function useResendOtp() {
    const [timeLeft, setTimeLeft] = useState(60)

    const resetTimer = () => {
        setTimeLeft(60)
    }

    useEffect(() => {
        let timer = setInterval(() => {
            if (timeLeft !== 0) setTimeLeft(prevState => prevState - 1)
        }, 1000)

        return () => clearInterval(timer)
    },[timeLeft])

    return { timeLeft, resetTimer }
}